import { call, put, select, takeLatest } from "redux-saga/effects";
import { LOAD_COURSES, UPDATE_COURSE } from "./constants";
import {
  loadCoursesSuccess,
  loadCoursesError
} from "./actions";

import history from "utils/history";
import requestWrapper from "utils/requestWrapper";

// utils
import api from "utils/api";
const { endpoint } = api;
import { getObjId } from "utils/helpers/helper.general";
import _local from "utils/localStorageUtils";

export function* loadCourses(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { role } = currentUser;
    const { options } = action;

    let queryOptions = {
        ...options,
      },
      itemsList = false;

    if (role == "teacher") {
      // we get the campaigns linked to the courses
      itemsList = yield requestWrapper(
        "POST",
        endpoint?.courses?.teacher?.attendancesList(getObjId(currentUser)),
        queryOptions,
        currentUser.token,
      );
    } 

    if (!itemsList?.data) {
      yield put(loadCoursesSuccess(false));
    } else {
      yield put(loadCoursesSuccess(itemsList?.data, itemsList?.appointments));
    }
  } catch (error) {
    yield put(loadCoursesError(error));
  }
}

// Individual exports for testing
export default function* agendaSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_COURSES, loadCourses);
}
